import React from "react";
import {connect} from "react-redux";
import {ActionsRow, DetailValue, FixedDropDownButton, Icon, modal, utils} from "@mc/mc-legacy";
import CustomPageLayout from "./CustomPageLayout";
import AdminMenu from "../administrace/lists/components/AdminMenu";
import IconButton from "../components/IconButton";
import SignerForm from "../administrace/forms/SignerForm";
import QSignAdminApi from "../api/gen/qsign/QSignAdminApi";
import * as podepisujiciActions from "../actions/podepisujiciActions";
import ItemListFixed from "../components/ItemListFixed";
import MessageEmptyList from "../components/MessageEmptyList";
import {Col, DropdownItem, Row} from "reactstrap";
import * as appUtils from "../utils/appUtils";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import * as icons from "@fortawesome/free-solid-svg-icons";
import * as groupMenuActions from "../actions/groupMenuActions";
import "./SignersPage.scss";

/**
 * Správa uživatelů.
 */
class UsersPage extends React.Component {

    componentDidMount() {
        const {dispatch} = this.props;
        dispatch(podepisujiciActions.setFilter("", null))
        this.fetchData(this.props, true);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.fetchData(nextProps, false);
    }

    fetchData = (props, forceFetch) => {
        const {dispatch} = props;
        dispatch(podepisujiciActions.fetchIfNeeded(forceFetch));

        if (forceFetch) {
            dispatch(groupMenuActions.invalidate());
        }
    };

    handleCreateUser = () => {
        const {dispatch, selectedPodepisujiciToFilter} = this.props;
        dispatch(
            modal.ModalActions.show(
                SignerForm,
                {
                    onSubmit: (data) => {
                        return QSignAdminApi.createSigner(data);
                    },
                    onSubmitSuccess: (result, dispatch) => {
                        dispatch(modal.ModalActions.hide());
                        dispatch(podepisujiciActions.fetchIfNeeded(true));
                    },
                    initialValues: {
                        pracovnik: {
                            "@class": "PracovnikVO",
                        },
                    },
                },
                "Nový uživatel",
                {}
            )
        );
    };

    handleEditUser = (item) => {
        const {dispatch, selectedPodepisujiciToFilter} = this.props;
        dispatch(
            modal.ModalActions.show(
                SignerForm,
                {
                    onSubmit: (data) => {
                        return QSignAdminApi.updateSigner(data.pracovnik.id, data);
                    },
                    onSubmitSuccess: (result, dispatch) => {
                        dispatch(modal.ModalActions.hide());
                        dispatch(podepisujiciActions.fetchIfNeeded(true));
                    },
                    initialValues: item,
                },
                "Úprava uživatele",
                {}
            )
        );
    };
    handleDeleteUser = (item) => {
        const {dispatch, selectedPodepisujiciToFilter} = this.props;
        const pracovnik = item.pracovnik;
        dispatch(
            modal.ModalActions.showConfirm(
                "Potvrzení smazání",
                "Opravdu chcete smazat uživatele " + appUtils.getPracovnikLabel(pracovnik) + "?",
                () =>
                    QSignAdminApi.deleteSigner(pracovnik.id).then(() => {
                        dispatch(podepisujiciActions.fetchIfNeeded(true));
                    }),
                null,
                "Potvrdit"
            )
        );
    };

    renderItem = (item, key) => {
        const pracovnik = item.pracovnik;
        let role = [];
        if (item.canSign) {
            role.push('Podepisující')
        }
        if (item.canApprove) {
            role.push('Schvalovatel')
        }
        if (item.canCreateRequest) {
            role.push('Předkladatel')
        }
        const roleStr = role.join(', ')

        return (
            <ActionsRow className={"ml-3 mt-3"} actions={this.renderActions(item)}>
                <Row>
                    <Col>
                        <h2>
                            {appUtils.getPracovnikLabel(pracovnik)}{" "}
                            {item.blocked && <FontAwesomeIcon className="blocked" title="Zablokováno"
                                                              icon={icons.faBan}/>}{" "}
                        </h2>
                    </Col>
                </Row>
                <Row className={"mt-2"}>
                    <Col xs={12} md={4}>
                        <DetailValue textOverflow label="Uživatelské jméno" valueTitle={pracovnik.loginName}>
                            {pracovnik.loginName}
                        </DetailValue>
                    </Col>
                    <Col xs={12} md={4}>
                        <DetailValue textOverflow label="E-Mail" valueTitle={pracovnik.email}>
                            {pracovnik.email ? pracovnik.email : "-"}
                        </DetailValue>
                    </Col>
                    <Col xs={12} md={4}>
                        <DetailValue textOverflow label="HSM Login" valueTitle={item.hsmId}>
                            {item.hsmId ? item.hsmId : "-"}
                        </DetailValue>
                    </Col>
                </Row>
                <Row className={"mt-1"}>
                    <Col xs={12} md={4}>
                        <DetailValue textOverflow label="Role" valueTitle={roleStr}>
                            {roleStr}
                        </DetailValue>
                    </Col>
                </Row>
            </ActionsRow>

        );
    };

    renderActions = (item) => {
        return (
            <Col className="item-actions">
                <FixedDropDownButton color="action" noCaret
                                     title={<Icon icon="ellipsis-v" className="item-actions-icon"/>}>
                    <DropdownItem key="1" onClick={() => this.handleEditUser(item)}>
                        Upravit
                    </DropdownItem>
                    <DropdownItem key="2" onClick={() => this.handleDeleteUser(item)}>
                        Smazat
                    </DropdownItem>
                </FixedDropDownButton>
            </Col>
        );
    };

    render() {
        const {itemList} = this.props;

        const listProps = {
            itemList,
            loadMore: podepisujiciActions.loadMore,
            invalidatePozadavky: podepisujiciActions.invalidate,
            renderItem: this.renderItem,
            className: "signer-list",
            emptyList: (
                <MessageEmptyList>
                    <div className="message">
                        Žádní uživatelé
                        <div className="thumbup">
                            <Icon icon="thumbs-o-up fa-4x"/>
                        </div>
                    </div>
                </MessageEmptyList>
            ),
        };

        return (
            <CustomPageLayout
                header
                customHeaderButton={<IconButton icon="plus" title="Nový uživatel"
                                                onClick={this.handleCreateUser}/>}
                headerButton={false}
                searchField={false}
                searchSignerField={true}
                title="Přehled uživatelů"
                menu={<AdminMenu/>}
            >
                <ItemListFixed {...listProps} />
            </CustomPageLayout>
        );
    }
}

function mapStateToProps(state) {
    return {
        selectedPodepisujiciToFilter: utils.storeFromArea(state, podepisujiciActions.SELECTED_PODEPISUJICI_TO_FILTER),
        itemList: utils.storeFromArea(state, podepisujiciActions.PODEPISUJICI_LIST),
    };
}

export default connect(mapStateToProps)(UsersPage);
